function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.65538 10.912H4.11938V3.096C4.11938 2.86133 4.12738 2.624 4.14338 2.384L2.09538 4.136C2.04204 4.17867 1.98871 4.21067 1.93538 4.232C1.88204 4.248 1.83138 4.256 1.78338 4.256C1.70338 4.256 1.63138 4.24 1.56738 4.208C1.50338 4.17067 1.45538 4.128 1.42338 4.08L0.975375 3.464L4.38338 0.511999H5.54338V10.912H7.79938V12H1.65538V10.912Z",
  fill: "currentColor"
});

var SvgOne = function SvgOne(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 8 12",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOne, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/one.af1ae6de.svg";
export { ForwardRef as ReactComponent };